import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b4048a72"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "first-screen" }
const _hoisted_2 = { class: "first-screen__container" }
const _hoisted_3 = { class: "first-screen__img" }
const _hoisted_4 = ["srcset"]
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "first-screen__text" }, [
  /*#__PURE__*/_createTextVNode(" Празднуем День молодежи вместе! "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Загрузи свою фотографию и узнай, "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" как бы ты выглядел в стиле 60-х, 70-х "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" или 80-х. Находи своих звездных "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" двойников и делись с друзьями! ")
], -1))
const _hoisted_7 = { class: "first-screen__buttons" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "first-screen__button-man-right" }, "Я — герой", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "first-screen__button-woman-left" }, "Я — героиня", -1))
const _hoisted_10 = ["src"]
const _hoisted_11 = ["src"]
const _hoisted_12 = ["src"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))

import LeftArrow from "@/components/svg/LeftArrow.vue";
import { inject } from "vue";
import { reachGoal } from "@/utils/reachGoal";

export default /*#__PURE__*/_defineComponent({
  __name: 'StartScreen',
  emits: ["select-gender"],
  setup(__props, { emit: __emit }) {

const data = inject("data");
const emit = __emit;

const onSelect = (data: "male" | "female") => {
  reachGoal(data === "male" ? "Im a hero" : "im a heroessa");
  emit("select-gender", data);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("picture", _hoisted_3, [
        _createElementVNode("source", {
          media: "(min-width: 780px)",
          srcset: _unref(data)['main-hero-desktop']
        }, null, 8, _hoisted_4),
        _createElementVNode("img", {
          src: _unref(data)['main-hero-mobile'],
          alt: "Главный герой"
        }, null, 8, _hoisted_5)
      ]),
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("button", {
          class: "first-screen__button-man",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (onSelect('male')))
        }, [
          _createVNode(LeftArrow, { class: "first-screen__button-man-left" }),
          _hoisted_8
        ]),
        _createElementVNode("button", {
          class: "first-screen__button-woman",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (onSelect('female')))
        }, [
          _hoisted_9,
          _createVNode(LeftArrow, { class: "first-screen__button-woman-right" })
        ])
      ]),
      _createElementVNode("img", {
        src: _unref(data)['people-mobile'],
        class: "first-screen__people"
      }, null, 8, _hoisted_10),
      _createElementVNode("img", {
        src: _unref(data).man,
        class: "first-screen__man"
      }, null, 8, _hoisted_11),
      _createElementVNode("img", {
        src: _unref(data).woman,
        class: "first-screen__woman"
      }, null, 8, _hoisted_12),
      _hoisted_13
    ])
  ]))
}
}

})